<template>
    <div>
        <!--Header Components-->
        <base-header class="mt-4 pb-6" type=""/>
        <b-container fluid class="mt--6">
          <div>
            <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
          </div>
          <b-row>
            <b-col lg="12">
              <div class="card-wrapper">
                <card>
                  <div slot="header" class="mb-0">
                    <b-row>
                      <b-col cols="8">
                          <h3>Customer {{language_terms['SOA']}}</h3>
                      </b-col>
                    </b-row>
                  </div>
                  <b-row>
                    <b-col md="12" >
                      <base-input :label="language_terms['DATE_AS_AT']">
                        <flat-picker v-model="filter.date" @on-change="onClickSearch()" slot-scope="{focus, blur}" @on-open="focus" @on-close="blur" style="background-color: white;" class="form-control datepicker"/>
                      </base-input>
                    </b-col>
                  </b-row>
                </card> 
              </div>
            </b-col>
          </b-row>
          <b-row v-if="items.length > 0">
            <b-col lg="12">
              <div class="card-wrapper">
                <card>
                  <div slot="header" class="mb-0">
                    <b-row>
                      <b-col lg="11">
                          <h3>Customers</h3>
                      </b-col>
                      <b-col lg="1">
                        <input class="Checkbox" type="checkbox" value="1" v-model="is_selected" switch @change="selectAll($event)">
                      </b-col>
                    </b-row>
                  </div>
                  <b-row class="mt--4">
                    <b-col cols="12" class="mt-3">
                      <b-table-simple hover responsive>
                        <b-thead head-variant="light">
                                <b-th>{{language_terms['SELECT']}}</b-th>
                                <b-th>{{language_terms['CUSTOMER']}}</b-th>
                                <b-th>{{language_terms['CURRENT']}} </b-th>
                                <b-th>{{'30 ' + language_terms['DAYS']}} </b-th>
                                <b-th>{{'60 ' + language_terms['DAYS']}} </b-th>
                                <b-th>{{'90 ' + language_terms['DAYS']}} </b-th>
                                <b-th>{{'> 90 ' + language_terms['DAYS']}} </b-th>
                                <b-th>{{language_terms['TOTAL']}} </b-th>
                            </b-thead>
                        <b-tbody>
                            <tr v-for="(row, i) in items" :key="i">
                              <td>
                                <input class="Checkbox" type="checkbox" value="1" v-model="row.is_selected" switch @change= "updateSelectedCount(row.is_selected)">
                              </td>
                              <td v-on:click="onClickrow(row)">{{row.contact_name}}</td>
                              <td v-on:click="onClickrow(row)">{{(row.amount_current * 1).toLocaleString('en-SG', {style: 'currency', minimumFractionDigits:2, maximumFractionDigits:2, currency: 'SGD', currencySign: 'accounting'})}}</td>
                              <td v-on:click="onClickrow(row)">{{(row.amount_30 * 1).toLocaleString('en-SG', {style: 'currency', minimumFractionDigits:2, maximumFractionDigits:2, currency: 'SGD', currencySign: 'accounting'})}}</td>
                              <td v-on:click="onClickrow(row)">{{(row.amount_60 * 1).toLocaleString('en-SG', {style: 'currency', minimumFractionDigits:2, maximumFractionDigits:2, currency: 'SGD', currencySign: 'accounting'})}}</td>
                              <td v-on:click="onClickrow(row)">{{(row.amount_90 * 1).toLocaleString('en-SG', {style: 'currency', minimumFractionDigits:2, maximumFractionDigits:2, currency: 'SGD', currencySign: 'accounting'})}}</td>
                              <td v-on:click="onClickrow(row)">{{(row.amount_a90 * 1).toLocaleString('en-SG', {style: 'currency', minimumFractionDigits:2, maximumFractionDigits:2, currency: 'SGD', currencySign: 'accounting'})}}</td>
                              <td v-on:click="onClickrow(row)">{{(row.amount_total * 1).toLocaleString('en-SG', {style: 'currency', minimumFractionDigits:2, maximumFractionDigits:2, currency: 'SGD', currencySign: 'accounting'})}}</td>
                            </tr>
                        </b-tbody>
                        <div class="floating-bar" v-if="selectedCount > 0">
                          <div class="floating-bar-container" align="center">
                              <b-button-group>
                                <b-button class="transparent-btn"  @click="onClickEmail()">
                                    <i class="fas fa-envelope mr-2 text-info"></i>{{language_terms['EMAIL']}}
                                </b-button>
                              </b-button-group>
                          </div>
                        </div>
                      </b-table-simple>
                    </b-col>
                  </b-row>                          
                </card>
              </div>
            </b-col>
          </b-row>
        </b-container>
    </div>
  </template>
<style>
th.VueTables__sortable {color:rgb(255,255,255);}
td.VueTables__row  {color:black}
.v-data-table /deep/ .sticky-header {position: sticky; top: var(--toolbarHeight);}
.v-data-table /deep/ .v-data-table__wrapper {overflow: unset;}
</style>
<style>
  input.Checkbox {width: 25px; height: 25px;}</style>
<script>
import moment from 'moment'
import { Select, Option, Checkbox } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue'

  export default {
    components:{
      Loading,
      [Select.name]: Select,
      [Option.name]: Option,
      flatPicker,
      PaginatedTables
    },
    computed:{
        ...mapState({
          language_terms: state => state.languages.language_terms,
          selected_lang: state => state.languages.selected_langauge,
      }),
    },
    async mounted()
    {
      this.loadingCounter++
      this.onClickSearch()
      this.loadingCounter--
    },

    data(){
      return{
        row: [],
        modalrow: false,
        reportOptions:{perPage:100, perPageValues:[],stickyHeader:false, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C', hiddenColumns:[],filterable:false},
        selectedCount: 0,
        is_selected: 1,
        selectedrow:[],
        loadingCounter:0,
        filter:{
          date:moment().format("YYYY-MM-DD"),
        },
        items:[],
        status_options:[
          {
            label:"Pending Approval",
            value:null
          },
          {
            label:"Approved",
            value:"1"
          },
          {
            label:"Rejected",
            value:"0"
          },
        ],
      }
    },
  
    methods:{
      async updateSelectedCount(is_checked)
      {
        if (is_checked)
          this.selectedCount++
        else
          this.selectedCount--
      },
      async selectAll()
      {
        this.selectedCount = 0
        for (let x = 0;x < this.items.length;x++)
        {
          this.items[x].is_selected = this.is_selected
          if (this.is_selected)
            this.selectedCount++
        } 
      },
      async onClickSearch()
      {
        this.loadingCounter++

        this.filter.limit = ''
        let payload = this.filter
            
        await axios
        .post(apiRoutes["REPORTS_GENERATE_CUSTOMER_SOA_SUMMARY_EMAIL"], payload, authHeader())
        .then((response) => 
        {
          if (response.data.code == 1) {
            this.items = response.data.data
            this.selectedCount = this.items.length
            this.is_selected = 1
          } 
          else 
            Vue.notify({group: "notify", type: "error", text: 'Interface error', max: 5, duration: 5000, speed: 300,});
        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: 'Network error', max: 5, duration: 5000, speed: 300,});
          }
        });
        this.loadingCounter--
      },
      
      async onClickEmail()
      {
        this.loadingCounter++
        this.filter.limit = ''
        let payload = {items:this.items, date: this.filter.date}

        await axios
        .post(apiRoutes["REPORTS_SEND_CUSTOMER_SOA_BULK_EMAIL"], payload, authHeader())
        .then((response) => 
        {
          if (response.data.code == 1) {
            Vue.notify({text: 'Selected Customer SOA queued for email..', type: "success", group: "notify", max: 5, duration: 5000, speed: 300,});

          } 
          else 
            Vue.notify({text: 'Interface error', type: "error", group: "notify", max: 5, duration: 5000, speed: 300,});
        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({text: error.response.data.msg, type: "error", group: "notify", max: 5, duration: 5000, speed: 300,});
          }
        });
        this.loadingCounter--
      },
    }
  }
  </script>
  